

if(typeof(MessageHelper) == "undefined" || !MessageHelper || !MessageHelper.topicNamespace){

	MessageHelper = {
		messages: {},

		identifier: "",

		tooltip: null,		
		focusElement: "",	

		getCurrentYear: function(){
			return new Date().getFullYear();
		}, 

		getCurrentMonth: function(){
       return new Date().getMonth()+1;
		}, 

		getCurrentDay: function(){
       return new Date().getDate();
		}, 

		getRenderContextProperty : function(context, propertyName){

						console.debug("enter getRenderContextProperty with propertyName = "+propertyName);
			if(context == null){
				console.debug("context is null. Return null...");
				return null;
			}

						var result = context.properties[propertyName]
			console.debug("the found property value is: "+result);

						return result;	
		}, 

		setMessage:function(key, msg) {
			this.messages[key] = msg;
		},
		setFocusElement:function(element){
			this.focusElement = element;
		},		



		showHideMessageArea:function(topOffset){
			cursor_clear();
			if (topOffset==null || topOffset==undefined) {
				topOffset = 0;
			}
			var node = dojo.byId("MessageArea");

						var fadeInAnimArgsArray = new Array();
			fadeInAnimArgsArray["node"] = node;
			fadeInAnimArgsArray["duration"] = 200;
			fadeInAnimArgsArray["delay"] = 0;


			dojo.style(node, "opacity", 0);
			if(dijit.byId("MessageArea_ACCE_Title") != null) {
				dijit.byId("MessageArea_ACCE_Title").style.display = "block";
			}
			dojo.style(node, "display", "block");

			var fadeInAnim = dojo.fadeIn(fadeInAnimArgsArray);


			fadeInAnim.play();
		},

		hideMessageArea:function(){
			cursor_clear();
			var focusOnElement = "";
			if(dojo.byId(this.focusElement)!=null){
				focusOnElement = dojo.byId(this.focusElement);
			}
			var node = dojo.byId("MessageArea");
			var fadeOutAnimArgsArray = new Array();
			fadeOutAnimArgsArray["node"] = node;
			fadeOutAnimArgsArray["duration"] = 500;
			fadeOutAnimArgsArray["onEnd"] = function(){
				dojo.style(node, "display", "none");
				if(dijit.byId("MessageArea_ACCE_Title") != null) {
					dijit.byId("MessageArea_ACCE_Title").style.display = "none"
				}
				dojo.style(node, "opacity", 100);
				if(dojo.byId(focusOnElement)!=null){
					focusOnElement.focus();	
				}			
			};
			dojo.fadeOut(fadeOutAnimArgsArray).play();
			dojo.byId('ErrorMessageText').innerHTML = "";
			this.focusElement = "";				
		},

		displayErrorMessage:function(msg, topOffset,showType){	
			try{

						if (topOffset==null || topOffset==undefined) {
				topOffset = 0;
			}

						if (showType == undefined || showType==null || showType==true){
				if(this.messages["ERROR_MESSAGE_TYPE"]!=null && this.messages["ERROR_MESSAGE_TYPE"]!='undefined'){
					var MsgType = this.messages["ERROR_MESSAGE_TYPE"]; 
					msg = MsgType + msg;
				}				
			}

						this.setMessageAreaStyle('error_icon');
			this.showHideMessageArea(topOffset);
			dojo.byId('clickableErrorMessageImg').focus();
			setTimeout(function() {if (dojo.byId('ErrorMessageText') != null) {dojo.byId('ErrorMessageText').focus();}}, 1000);

						}catch(err){
				if( msg.indexOf(" discontinued ") != -1 ){
					alert(msg);
				}else{
					console.log(err);
				}

							}
		},


		setMessageAreaStyle:function(styleId){
			if(dojo.byId(styleId) != null){dojo.byId(styleId).style.display="inline";}
		},


		displayStatusMessage:function(msg,topOffset){
			if (topOffset==null || topOffset==undefined) {
				topOffset = 0;
			}
			this.setMessageAreaStyle('success_icon');
			if(dojo.byId('clickableErrorMessageImg')!=null)
				dojo.byId('clickableErrorMessageImg').focus();


										setTimeout(function() {if (dojo.byId('ErrorMessageText') != null) {dojo.byId('ErrorMessageText').focus();}}, 1000);
		},

		hideAndClearMessage:function(){
		},

		formErrorHandle:function(serviceResponse,formName){

			this.formErrorHandleClient(serviceResponse.errorMessageParam, serviceResponse.errorMessage);

	  	},


		formErrorHandleClient:function(id,errorMessage){

						var element = dojo.byId(id);
			if (errorMessage == null){	
				console.debug("formErrorHandleClient: The error message is null.");
				return;
			}
			if(element){
				if (this.identifier != (id + "_tooltip")) {
					this.identifier = id + "_tooltip";
					var node = document.createElement('span');
					var imgDirPath = getImageDirectoryPath();
					if(dojo.isIE < 7)
					{
						node.innerHTML = errorMessage + "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" + imgDirPath + "images/empty.gif'></iframe>";
					}
					else
					{
						node.innerHTML = errorMessage;
					}
					var isRtl = dojo.some(['ar','he','iw'],function(item){return item === dojo.attr(dojo.body().parentNode,"lang")});
					var tooltip = new dijit.Tooltip({connectId: [id], dir: isRtl}, node);
					tooltip.startup();
					console.log("created", tooltip, tooltip.id);
					element.focus();
					var err_container = document.createElement('div');
					err_container.setAttribute('class', 'spanacce');
					err_container.setAttribute('role', 'alert');
					err_container.setAttribute('id', 'alert');
					var err_msg = document.createTextNode(errorMessage);
					err_container.appendChild(err_msg);
					document.body.appendChild(err_container);
					element.setAttribute('aria-invalid', 'true');

										tooltip.open(element); 
					dojo.connect(element, "onblur",  tooltip, "close"); 
					dojo.connect(element, "onblur",  tooltip, "destroy");
					dojo.connect(element, "onblur",  this, "clearCurrentIdentifier");
					tooltip._onMouseOver = this.emptyFunc;
					this.tooltip = tooltip;
				}
			}
		},

		hideFormErrorHandle:function(){
			if(this.tooltip != null){
				this.tooltip.destroyRecursive();
				this.tooltip = null;
				this.clearCurrentIdentifier();
			}
		},		

		clearCurrentIdentifier:function(){

					this.identifier = "";
	  },

	  emptyFunc:function(event){

		 	  },



		containsDoubleByte:function (target) {

						var str = new String(target);
				var oneByteMax = 0x007F;

				for (var i=0; i < str.length; i++){
					chr = str.charCodeAt(i);
					if (chr > oneByteMax) {
						return true;
					}
				}
				return false;
		},

		isValidEmail:function(strEmail){

						if (this.containsDoubleByte(strEmail)){
				return false;
			}

					if(strEmail.length == 0) {
				return true;
			} else if (strEmail.length < 5) {
					 return false;
				}else{
					if (strEmail.indexOf(" ") > 0){
								return false;
						}else{
							if (strEmail.indexOf("@") < 1) {
										return false;
								}else{
									if (strEmail.lastIndexOf(".") < (strEmail.indexOf("@") + 2)){
												return false;
										}else{
												if (strEmail.lastIndexOf(".") >= strEmail.length-2){
													return false;
												}
										}
								}
						}
				}
				return true;
		},

		isValidUTF8length: function(UTF16String, maxlength) {
			if (this.utf8StringByteLength(UTF16String) > maxlength) return false;
			else return true;
		},

		utf8StringByteLength: function(UTF16String) {

			if (UTF16String === null) return 0;

						var str = String(UTF16String);
			var oneByteMax = 0x007F;
			var twoByteMax = 0x07FF;
			var byteSize = str.length;

						for (i = 0; i < str.length; i++) {
				chr = str.charCodeAt(i);
				if (chr > oneByteMax) byteSize = byteSize + 1;
				if (chr > twoByteMax) byteSize = byteSize + 1;
			}  
			return byteSize;
		},

		IsNumeric : function (text,allowDot)
		{
			if(allowDot) var ValidChars = "0123456789.";
			else var ValidChars = "0123456789";

		  			var IsNumber=true;
			var Char;


		 			for (i = 0; i < text.length && IsNumber == true; i++) 
			{ 
				Char = text.charAt(i); 
				if (ValidChars.indexOf(Char) == -1) 
				{
					IsNumber = false;
				}
			}
			return IsNumber;   
		},

		IsValidPhone : function (text)
		{

					var ValidChars = "0123456789";

		  			var IsValid=true;
			var Char;

		 			for (i = 0; i < text.length && IsValid == true; i++) 
			{ 
				Char = text.charAt(i); 
				if (ValidChars.indexOf(Char) == -1) 
				{
					IsValid = false;
				}
			}
			return IsValid;   
		},

		IsValidZipCode : function (text)
		{

					var ValidChars = "0123456789";

		  			var IsValid=true;
			var Char;

		 			for (i = 0; i < text.length && IsValid == true; i++) 
			{ 
				Char = text.charAt(i); 
				if (ValidChars.indexOf(Char) == -1) 
				{
					IsValid = false;
				}
			}
			return IsValid;   
		}

			}

	}
